import { Component, OnInit, AfterViewInit } from '@angular/core';
import 'rxjs/add/operator/map';
import { CurrencyPipe } from '@angular/common';
import { CellButtonComponent } from '../../shared/grid/buttons/cell-button.component';
import { MatDialog } from '@angular/material';
import { TerminListComponent } from './termin-list/termin-list.component';
import { ZahlungListComponent } from './zahlung-list/zahlung-list.component';
import { AgGridServer } from '../ag-grid-server.service';
import { DialogData, KeyValuePair, NotifyService } from '../../shared/shared';
import { DataExportService, IExcelExportData } from '../../shared/data-export.service';
import { GridOptions, IServerSideGetRowsParams } from "ag-grid-community";
import "ag-grid-enterprise";

@Component({
  selector: 'vertrag-list',
  templateUrl: 'vertrag-list.component.html',
  styleUrls: ['vertrag-list.component.css']
})

export class VertragListComponent {
  public DEFAULT_REALESTATE_FILTER = "all";
  public gridOptions: GridOptions;
  public rowData: any[];
  public gridApi: any;
  public gridColumnApi: any;
  public realEstates: KeyValuePair[];
  public selectedRealEstate: any;

  private columnDefinitions: any[];
  private serverRequestExtension: any;
  constructor(
    public dialog: MatDialog,
    public cp: CurrencyPipe,
    public agGridServer: AgGridServer,
    private dataExportService: DataExportService,
    private notfiySrv: NotifyService
  ) {
    this.PopulateRealEstateDropdown();
    this.CreateColumnDefinitions();
    this.SetGridOptions();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.setServerSideDatasource(this.ServerSideDataSource);
  }

  public OnSelectedRealEstate(event) {
    this.selectedRealEstate = event.value;
    this.DisplaySelectedRealestateData(event.value);
  }

  public PopulateRealEstateDropdown() {
    this.agGridServer.GetRealEstates().subscribe((dictionary: any) => {
      this.realEstates = Object.keys(dictionary).filter(key => key !== "$id").map(key => { return new KeyValuePair(key, dictionary[key]) });
    })
  }

  public Export() {
    if (!this.selectedRealEstate) {
      this.notfiySrv.TME("Fehler", "Bitte wählen WHA Sie aus der Liste");
      return;
    }

    this.agGridServer.GetFlatsByrealEstate(this.selectedRealEstate).subscribe(flats => {
      let columnDefinitions = this.GetColumnsForExport();
      let data: IExcelExportData = this.dataExportService.ExtractDataForExcelExport(columnDefinitions, flats);
      this.dataExportService.ExportAsExcel(data);
    })

  }

  private ServerSideDataSource = {
    getRows: this.GetRowsFromServer.bind(this),
    destroy: (destroy) => { console.log(destroy) }
  }

  private GetRowsFromServer(params: IServerSideGetRowsParams) {
    if (this.serverRequestExtension)
      Object.assign(params.request, this.serverRequestExtension);

    this.agGridServer.Get(params.request)
      .subscribe((response) => {
        if (response) {
          params.successCallback(response.Rows, response.LastRowIndex);
        } else {
          params.failCallback();
        }
      });
  }

  private GetColumnsForExport() {
    let columns = this.gridColumnApi.getAllColumns().filter(col => col.colId != "TermineNumber" && col.colId != "Ampel" && col.colId != "AnlageId" && col.colId != "ZahlungenNumber" && (col.visible || col.colId == "BezeichnungExternesPortal"));
    return columns;
  }

  private DisplaySelectedRealestateData(name: string) {
    this.serverRequestExtension = {}
    let expandFirst: boolean = false;

    if (name != this.DEFAULT_REALESTATE_FILTER) {
      this.serverRequestExtension = { filterModel: { "anlage.ace_wohnhausanlageid": name } };
      expandFirst = true;
    }

    this.gridApi.purgeServerSideCache();

    expandFirst ? this.gridApi.getRenderedNodes()[0].setExpanded(true) : null;
  }

  private monthToComparableNumber(date) {
    if (date === undefined || date === null || date.length < 10) {
      return null;
    }

    let yearNumber = date.substring(6, 10);
    let monthNumber = date.substring(3, 5);
    let dayNumber = date.substring(0, 2);

    var result = (yearNumber * 10000) + (monthNumber * 100) + dayNumber;
    return result;
  }

  private dateComparator(date1, date2) {
    var date1Number = this.monthToComparableNumber(date1);
    var date2Number = this.monthToComparableNumber(date2);

    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }

    return date1Number - date2Number;
  }

  private CreateColumnDefinitions() {

    this.columnDefinitions = [
      {
        headerName: "Id",
        field: "id",
        hide: true,
        suppressMenu: true
      },
      {
        headerName: "ParkingLotWithRealEstate",
        field: "ParkingLotWithRealEstate",
        hide: true,
        suppressMenu: true
      },
      {
        headerName: "Bezeichnung Wohnhausanlage",
        field: "BezeichnungExternesPortal",
        width: 250,
        hide: true
      },
      {
        headerName: "Bezeichnung Wohnhausanlage",
        field: "AnlageId",
        width: 250,
        rowGroup: true,
        suppressMenu: true,
        resizable: true,
        sortable: true,
        cellRenderer: function (params) {
          // To leave it empty on expand.
          return;
        }
      },
      {
        headerName: "Straße",
        field: "WohnungStrasse",
        width: 150,
        suppressMenu: true,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Anlage Straße",
        field: "AnlageStrasse",
        width: 150,
        suppressMenu: true,
        hide: true,
      },
      {
        headerName: "Stiege\\Haus Nr.",
        field: "StiegeNr",
        width: 100,
        suppressMenu: true,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Top",
        field: "Top",
        width: 70,
        suppressMenu: true,
        sortingOrder: ['asc', 'desc'],
        sort: 'asc',
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Stellplatz",
        field: "Stellplatz",
        width: 130,
        suppressMenu: true,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Stellplatz 2",
        field: "Stellplatz2",
        width: 130,
        suppressMenu: true,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Stellplatz 3",
        field: "Stellplatz3",
        width: 130,
        suppressMenu: true,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Stellplatz 4",
        field: "Stellplatz4",
        width: 130,
        suppressMenu: true,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Kaufer 1",
        field: "Kaufer1",
        width: 130,
        suppressMenu: true,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Kaufer 2",
        field: "Kaufer2",
        width: 110,
        suppressMenu: true,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Besprechungstermin",
        field: "Besprechungstermin",
        resizable: true,
        sortable: true,
        cellRenderer: function (params) {
          if (params.value)
            return params.value.split(' ')[0];

          return '';
        },
        width: 110,
        sortingOrder: ['asc', 'desc'],
        suppressMenu: true,
        comparator: this.dateComparator.bind(this)
      },
      {
        headerName: "KV Termin",
        field: "KVTermin",
        resizable: true,
        sortable: true,
        cellRenderer: function (params) {
          if (params.value)
            return params.value.split(' ')[0];

          return '';
        },
        width: 110,
        sortingOrder: ['asc', 'desc'],
        suppressMenu: true,
        comparator: this.dateComparator.bind(this)
      },
      {
        headerName: "Termine",
        field: "TermineNumber",
        width: 80,
        resizable: true,
        cellRendererFramework: <{ new(): CellButtonComponent }>CellButtonComponent,
        cellRendererParams: {
          onClick: this.onTerminDialogOpen.bind(this),
          Tooltip: "Termine anzeigen",
          icon: "access_time"
        },
        suppressMenu: true
      },
      {
        headerName: "Status",
        field: "Ampel",
        width: 80,
        resizable: true,
        sortable: true,
        cellRenderer: function (params) {
          if (params.value) {
            let message = "";
            switch (params.value) {
              case "red":
                message = "noch kein Termin vergeben";
                break;
              case "yellow":
                message = "Termin vergeben, aber noch nicht erfüllt";
                break;
              case "green":
                message = "Termin erfolgreich";
                break;
              default:
                break;
            }
            return '<div class="ampel ' + params.value + ' kreis"></div>';
          }
          return;
        },
        suppressMenu: true
      },
      {
        headerName: "Rechtswirksam",
        field: "Rechtswirksam",
        width: 110,
        resizable: true,
        sortable: true,
        suppressMenu: true
      },
      {
        headerName: "Zahlungen",
        field: "ZahlungenNumber",
        width: 90,
        resizable: true,
        cellRendererFramework: <{ new(): CellButtonComponent }>CellButtonComponent,
        cellRendererParams: {
          onClick: this.onZahlungDialogOpen.bind(this),
          Tooltip: "Zahlungen anzeigen",
          icon: "euro_symbol"
        },
        suppressMenu: true
      },
      {
        headerName: "Eingangsdatum Vollzahlung",
        field: "Eingangsdatum",
        width: 120,
        resizable: true,
        sortable: true,
        cellRenderer: function (params) {
          if (params.value)
            return params.value.split(' ')[0];

          return '';
        },
        suppressMenu: true,
        comparator: this.dateComparator.bind(this)
      },
      {
        headerName: "Kaufpreis vollständig eingelangt",
        field: "KaufpreisVollstaendig",
        width: 120,
        resizable: true,
        sortable: true,
        cellRenderer: function (params) {
          if (params.value) {
            return '<div class="cell-ampel"> <span>' + params.value + '</span></div>';
          }
          return;
        },
        suppressMenu: true
      },
      {
        headerName: "Übergabe möglich",
        field: "RechtswirksamAmpel",
        width: 80,
        resizable: true,
        sortable: true,
        cellRenderer: function (params) {
          if (params.value) {
            return '<div class="ampel ' + params.data.RechtswirksamAmpel + ' kreis"></div>';
          }
          return;
        },
        suppressMenu: true
      }
    ];
  }

  private SetGridOptions() {
    this.gridOptions = {
      rowSelection: 'single',
      cacheBlockSize: 50,
      paginationPageSize: 15,
      rowModelType: "serverSide",
      autoGroupColumnDef: { width: 150 },
      animateRows: true,
      suppressPaginationPanel: false,
      suppressCellSelection: true,
      rowGroupPanelShow: 'never',
      maxConcurrentDatasourceRequests: 1,
      suppressContextMenu: true,

      columnDefs: this.columnDefinitions,
      onGridSizeChanged: function (params) {
        params.api.sizeColumnsToFit();
      },
      onViewportChanged: function (params) {
        params.api.sizeColumnsToFit();
      },
    };

    this.gridOptions.groupUseEntireRow = true;
    this.gridOptions.groupRowInnerRenderer = function (params) {
      return `${params.node.data.BezeichnungExternesPortal}`;
    };
  }

  private onTerminDialogOpen(params) {
    this.dialog.open(TerminListComponent, {
      width: '1000px',
      height: '400px',
      data: new DialogData("Termine", null, "Abbrechen", params.data.Termine),
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  private onZahlungDialogOpen(params) {
    this.dialog.open(ZahlungListComponent, {
      width: '1000px',
      height: '400px',
      data: new DialogData("Zahlungen", null, "Abbrechen", params.data.Zahlungen),
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/_vertrag/vertrag-list/vertrag-list.component.ts